module.exports = __webpack_public_path__ + "img/e229c80.svg";